export default __webpack_public_path__ + "static/media/edoc.b67c50d3.png";